import { render, staticRenderFns } from "./ResultTopicConfirm.vue?vue&type=template&id=59e940fa&scoped=true"
import script from "./ResultTopicConfirm.vue?vue&type=script&lang=js"
export * from "./ResultTopicConfirm.vue?vue&type=script&lang=js"
import style0 from "./ResultTopicConfirm.vue?vue&type=style&index=0&id=59e940fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e940fa",
  null
  
)

export default component.exports